<div class="translation-feedback">
  <nz-row [nzGutter]="[15, 0]" class="align-center">
    <nz-col>
      <span *ngIf="isManager && likesCount" class="translation-feedback-count">
        {{ likesCount }}
      </span>
      <button
        nz-button
        class="btn-like"
        [class.active]="isLikeActive"
        [nzShape]="'circle'"
        [nzLoading]="translationFeedbackDeleting$[FeedbackTypeEnum.Like] | async"
        (click)="openLotTranslationsFeedbackModal(FeedbackTypeEnum.Like)"
      >
        <span nz-icon nzType="like" nzTheme="outline"></span>
      </button>
    </nz-col>

    <nz-col>
      <span *ngIf="isManager && dislikesCount" class="translation-feedback-count">
        {{ dislikesCount }}
      </span>
      <button
        nz-button
        class="btn-dislike"
        [class.active]="isDislikeActive"
        [nzShape]="'circle'"
        [nzLoading]="translationFeedbackDeleting$[FeedbackTypeEnum.Dislike] | async"
        (click)="openLotTranslationsFeedbackModal(FeedbackTypeEnum.Dislike)"
      >
        <span nz-icon nzType="dislike" nzTheme="outline"></span>
      </button>
    </nz-col>
  </nz-row>
</div>
